import { RootState } from 'types'

type State = RootState['articleInformalFeedbackRequestsFetchRequests']

export default function reduce(state: State = {}, { type, payload }: any): State {
  switch (type) {
    case 'UPSERT_ARTICLE_INFORMAL_FEEDBACK_REQUESTS_FETCH_REQUEST': {
      return { ...state, [payload.articleKey]: payload.state }
    }
    default:
      return state
  }
}
